import { select } from 'redux-saga/effects';
export function* appSelect(selector, ...args) {
  const result = yield select(state => {
    return selector(state, ...args);
  });
  return result;
}